<div class="bg-sara-blue section-1 text-center flex flex-column justify-content-center">
    <div class="flex justify-content-center">
        <img alt="Sara Plus" class="relative w-6 sm:w-4 md:w-3 lg:w-2" src="assets/images/logo/SARAWhiteLogoBorderless.png">
    </div>    
    <div class="mt-5 mb-5 font-semibold	text-md text-white">One Application. One Platform. 
        All Devices.</div>
</div>
<div class="section-2 flex flex-column justify-content-center">
    <h3 class="mt-0 text-center font-semibold text-xl">About Us</h3>
    <h3 class="mt-0 font-semibold text-lg">Who We Are</h3>
    <ul class="mb-3 pb-1">
        <li>
            We are the preferred order entry software for the top service providers in the country such as AT&T and DIRECTV. 
        </li>
    </ul>
    <h3 class="mt-0 font-semibold text-lg">What We Do</h3>
    <ul>
        <li>
            We process over <strong>250,000</strong> orders per month and <strong>30%</strong> of all AT&T wireless sales run through our software.
        </li>
    </ul>
</div>
<div class="section-3 flex flex-column">
    <h3 class="my-0 text-center pb-4 font-semibold text-xl">Features & Services</h3>
    <div class="flex flex-column" style="gap: 20px !important">
        <div class="flex justify-content-start gap-2">
            <i class="pi pi-circle-green-verified text-4xl"></i>
            <span class="line-height-3">
                Easy-to-learn sales interface ideally suited to new sellers
            </span>
       </div>
       <div class="flex justify-content-start gap-2">
            <i class="pi pi-circle-green-verified text-4xl"></i>
            <span class="line-height-3">
                Specialized order support and troubleshooting via Chat, Phone, and Email 
            </span>
       </div>
       <div class="flex justify-content-start gap-2">
            <i class="pi pi-circle-green-verified text-4xl"></i>
            <span class="line-height-3">
                Secure Data Collection with multiple layers of protection
            </span>
        </div>
        <div class="flex justify-content-start gap-2">
            <i class="pi pi-circle-green-verified text-4xl"></i>
            <span class="line-height-3">
                First Party Verification
            </span>
        </div>
        <div class="flex justify-content-start gap-2">
            <i class="pi pi-circle-green-verified text-4xl"></i>
            <span class="line-height-3">
                Robust and detailed reporting
            </span>
        </div>    
    </div>
</div>

<div class="section-4 flex flex-column justify-content-center">
    <h2 class="mt-0 mb-4 font-semibold text-xl text-center">Advanced Capabilities</h2>
  
    <div class="mt-0 mb-4 font-semibold text-center line-height-3">We have built a trusted and integrated infrastructure for businesses to deliver an exceptional experience for everyone. By innovating through simplicity, we provide customers a reliable and streamlined sales process.</div>
    <div class="mt-0 mb-5 pb-2 font-semibold text-lg text-sara-blue text-center">Explore some of the capabilities offered with SARA Plus™ access.</div>

    <div class="flex flex-column mb-5">
        <div class="flex align-items-center mb-4">
            <div class="bg-icon">
                <i class="pi pi-order-entry icon-20"></i>
            </div>
            <span class="font-semibold">Order Entry</span>
        </div>
        <div class="grid">
            <div class="col-12 p-0 sm:col-6 sm:p-auto">
                <ul>
                <li>DIRECTV & AT&T Integration</li>
                </ul>
            </div>
            <div class="col-12 p-0 sm:col-6 sm:p-auto">
                <ul>
                <li>Over 70% of AT&T Indirect Channel 
                    orders</li>
                </ul>
            </div>
        </div>
    </div>
    
    <div class="flex flex-column mb-5">
        <div class="flex align-items-center mb-4">
            <div class="bg-icon">
                <i class="pi pi-reporting icon-20"></i>
            </div>
            <span class="font-semibold">Reporting</span>
        </div>
        <div class="grid">
            <div class="col-12 p-0 sm:col-6 sm:p-auto">
                <ul>
                    <li>Sales Dashboard</li>
                    <li>Sales Order History</li>
                    <li>Pending Orders</li>
                    <li>Activities</li>
                </ul>
            </div>
            <div class="col-12 p-0 sm:col-6 sm:p-auto">
                <ul>
                    <li>Install Dashboard</li>
                    <li>Third Party Verification Process</li>
                    <li>Leads</li>
                </ul>
            </div>
        </div>
    </div>

    <div class="flex flex-column mb-5">
        <div class="flex align-items-center mb-4">
            <div class="bg-icon">
                <i class="pi pi-secure-data icon-20"></i>
            </div>
            <span class="font-semibold">Support & Fraud Protection</span>
        </div>
        <div class="grid">
            <div class="col-12 p-0 sm:col-6 sm:p-auto">
                <ul>
                    <li>Live Chat Support</li>
                </ul>
            </div>
            <div class="col-12 p-0 sm:col-6 sm:p-auto">
                <ul>
                    <li>Continuous S+ Platform Updates</li>
                </ul>
            </div>
        </div>
    </div>

    <div class="flex flex-column">
        <div class="flex align-items-center mb-4">
            <div class="bg-icon">
                <i class="pi pi-admin icon-20"></i>
            </div>
            <span class="font-semibold">Admin</span>
        </div>
        <div class="grid">
            <div class="col-12 p-0 sm:col-6 sm:p-auto">
                <ul>
                    <li>User Management</li>
                    <li>Multiple Accounts</li>
                    <li>Multiple Campaigns</li>
                    <li>Fraud Settings</li>
                </ul>
            </div>
            <div class="col-12 p-0 sm:col-6 sm:p-auto">
                <ul>
                    <li>Notification Manager</li>
                    <li>Sales Location Management</li>
                    <li>IP Restriction</li>
                </ul>
            </div>
        </div>
    </div>
</div>
<div class="section-5 text-center flex flex-column justify-content-center">
    <h2 class="mt-0 mb-0 font-semibold text-xl">Available Providers</h2>
    <div class="flex flex-column gap-5 sm:flex-row my-5 py-2 justify-content-center">
        <div class="flex justify-content-center">
            <img alt="Att Wireless"class="relative h-2rem" src="assets/icons/pi-att-wireless.svg">
        </div> 
        <div class="flex justify-content-center">
            <img alt="ATT Internet" class="relative h-2rem" src="assets/icons/pi-att-internet.svg">
        </div>    
        <div class="flex justify-content-center">
            <img alt="DIRECTV" class="relative h-2rem" src="assets/icons/pi-directv.png">
        </div>    
    </div>
    <div class="flex justify-content-center font-semibold text-lg">
        + over 15 more providers!
   </div>
   <p-divider class="mx-3  py-3"></p-divider>
   <h2 class="mt-0 mb-3 font-semibold text-xl">Let's Get in Touch</h2>
   <p-button class="text-center align-items-center" [label]="'sales&#64;saraplus.com'" [icon]="'pi pi-envelope'" [link]="true" (onClick)="onEmailClicked()"></p-button>
</div>

